var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarpeta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 66.31 59.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clip-path);filter:url(#luminosity-noclip);}.cls-2{fill:none;}.cls-3{isolation:isolate;}.cls-4{clip-path:url(#clip-path-2);}.cls-5{clip-path:url(#clip-path-3);}.cls-6{clip-path:url(#clip-path-4);filter:url(#luminosity-noclip-2);}.cls-7{clip-path:url(#clip-path-5);}.cls-8{clip-path:url(#clip-path-6);}.cls-9{fill:#393d3d;}.cls-10{mask:url(#mask);}.cls-11{opacity:0.19;mix-blend-mode:multiply;}.cls-12{clip-path:url(#clip-path-7);}.cls-13{clip-path:url(#clip-path-8);}.cls-14{clip-path:url(#clip-path-9);}.cls-15{mask:url(#mask-2);}.cls-16{clip-path:url(#clip-path-10);}.cls-17{clip-path:url(#clip-path-11);}.cls-18{clip-path:url(#clip-path-12);}.cls-19{fill:#ededed;}.cls-20{fill:#d1d1d1;}.cls-21{fill:#71b55a;}.cls-22{fill:#3d8229;}.cls-23{fill:#656768;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.66,
    y: 37.87,
    width: 62.61,
    height: 20.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.08,58.66a2.94,2.94,0,0,0,.82.09c2.15,0,3.7,0,6,0l46.48-.12h6c.94,0,1.37,0,2.39-.09.45-.08.43-.28.43-.46v-.35l0-7.67,0-12.16H57.78l-51.67,0H3.87c0,4.52-.23,8-.21,12.53,0,1.92,0,6.27,0,6.27s0,.77,0,.94,0,.31,0,.45.14.51.33.56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.64,
    y: 37.88,
    width: 62.63,
    height: 20.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.81,
    y: 0.7,
    width: 39.43,
    height: 50.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.1,50.6c.3.22.3.22.52.22,1.35,0,2.33,0,3.8,0l29.26-.05h3.78A4.24,4.24,0,0,0,65,50.56c.28-.2.27-.68.27-1.11v-.84q0-9.22,0-18.44,0-14.62,0-29.25H63.59l-3.75,0L27.32.72H25.91c0,10.87-.12,19.25-.1,30.12,0,4.61.12,11.72.19,16.32-.13,0,0,.92,0,1.33s-.09.49-.09.81a2.68,2.68,0,0,0,.18,1.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.79,
    y: 0.71,
    width: 39.46,
    height: 50.15
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 3.43,
    y: 37.58,
    width: 62.88,
    height: 21.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 3.43,
    y: 37.58,
    width: 62.88,
    height: 21.6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("image", {
    width: 131,
    height: 45,
    transform: "translate(3.43 37.58) scale(0.48)",
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.66,
    y: 37.87,
    width: 62.61,
    height: 20.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.08,58.66a2.94,2.94,0,0,0,.82.09c2.15,0,3.7,0,6,0l46.48-.11,6,0c.94,0,1.37,0,2.39-.08.45-.08.43-.28.43-.46v-.35l0-7.67,0-12.17H57.78l-51.67,0H3.87c0,4.52-.23,8-.21,12.53,0,1.92,0,6.26,0,6.26s0,.78,0,.95,0,.31,0,.44.14.52.33.57"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.64,
    y: 37.87,
    width: 62.63,
    height: 20.89
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 25.51,
    y: 0.62,
    width: 39.84,
    height: 50.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 25.51,
    y: 0.62,
    width: 39.84,
    height: 50.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("image", {
    width: 83,
    height: 105,
    transform: "translate(25.51 0.62) scale(0.48)",
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.81,
    y: 0.7,
    width: 39.43,
    height: 50.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.1,50.6c.3.21.3.21.52.22,1.35,0,2.33,0,3.8,0l29.26-.05h3.78A4.24,4.24,0,0,0,65,50.56c.28-.2.27-.68.27-1.11V48.6q0-9.21,0-18.43,0-14.62,0-29.25H63.59l-3.75,0L27.32.71H25.91c0,10.87-.12,19.25-.1,30.12,0,4.61.12,11.72.19,16.32-.13,0,0,.92,0,1.33s-.09.49-.09.81a2.68,2.68,0,0,0,.18,1.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.79,
    y: 0.71,
    width: 39.46,
    height: 50.15
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 1laptop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M25.76,14.67V11.42a3.27,3.27,0,0,0-3.28-3.27H6.4a3.26,3.26,0,0,0-3.27,3.27V53.59A3.27,3.27,0,0,0,6.4,56.86H61.86a3.27,3.27,0,0,0,3.27-3.27V21.22a3.27,3.27,0,0,0-3.27-3.28H29a3.27,3.27,0,0,1-3.28-3.27"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("image", {
    width: 131,
    height: 45,
    transform: "translate(3.43 37.58) scale(0.48)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIMAAAAtCAYAAACNi9j4AAAACXBIWXMAABcRAAAXEQHKJvM/AAABfklEQVR4Xu3bXY6DIBSG4QNxK83sAPZZuym6KefK0x9RmClWhPdJTJOWi8L5ELTVhBCmewgCDPcQZLxeRUTEGCPTNOlra1ruVwk21QD9IAxQhAGKMEARBqiXMLS400Y+zgxQhOHkSt1jECEMeEIYoAgDFGGA6ioMXDpvewnDvDNtddBK7rxb1NWZAdsIAxRhgCIMUPxQBaVhYKcNlgkoDQNLBCzPTGBmfi6XqYezAs9MpNkWByiml35+wpZMVu166ut/RH+oatX86CDiuOl0ciVrtrjP0PrM4eywbhGGHgar5GxqyRB7s4fBOuOl5t6TNBoGkXMO1l/k9m3vAtTEOu/FGLM4jhT7PkcdPbHOudUPUwO114FjrC4T+K7cZSum1AQiDB/4pIA1GkQel5PPnSuVttq0VsCSBpFH4d8D8D5wRwWEAn7H5jIRK36sMLntUF7JCZrcM+QUNacN6pcMQ8nkoW7WeZ9qgw4478XM/3m7jWOqfZWc97J14wz5fgGE03tXdYDsnAAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("image", {
    width: 83,
    height: 105,
    transform: "translate(25.51 0.62) scale(0.48)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAABpCAYAAABGUx/LAAAACXBIWXMAABcRAAAXEQHKJvM/AAABvElEQVR4Xu3d0W3CMBRAURsxC+oEeCmyDGGpdKnXj6pUlKom4Qbsco/E35NAV3YSiSjJ4/EYp3FMXyIiPVvOeZXfsS8llVJqY4ttawP/yfs0pfdpqo2d5ZxrIxc2tQHdrsmYa2zxR2gyZq+ajDn3WNWKJmP2qsmYHjNBbnMZk2RMkDFBxgQZE2RMkDFBxgQZE2RMkDFBxgQZE2RMkDFBxgQZE2RMkDFBxgQZE2RMkDFBxgQZE2RMkDFBxgQZE2RMkDFBxgQZE2RMkDFBxgQZE2RMkDFBxgQZE2RMkDFBxgQZE2RMkDFBxgQZE2RMUJMxfeCJ1n2wXq9PgVnqHDMiUs755QKQLrZ5r8eqVnjMBJ1jur3v58oEGRNkTJAxQVcxvTxazpUJMiboIqbXmve5WpkGXc5tDjImyJggY4KMCTImyJggY4KMCTImyJggY4KMCTImyJggY4KMCTImyJigVW927c3Pewbm/h+22a/4vu+5IuKpn3vliIi33e7PIeKLejR3ZW5T+o611hvvX4W3YYO2p3GcvZz1Oy+NQE2dzXt309lcdYdh+DybH4YhncaxNt+UwzDURh5qX0r6AMY2pAT+bsmgAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M25,48,24.94.49a.42.42,0,0,1,.42-.42L62.81,0a.42.42,0,0,1,.42.42L63.32,48a.42.42,0,0,1-.42.42l-37.45.07A.42.42,0,0,1,25,48"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 33.28,
    y: 12.83,
    width: 25.05,
    height: 0.62,
    transform: "translate(-0.02 0.09) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 28.91,
    y: 16.09,
    width: 29.43,
    height: 0.62,
    transform: "translate(-0.03 0.08) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 28.91,
    y: 19.8,
    width: 29.43,
    height: 0.62,
    transform: "translate(-0.04 0.08) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 28.92,
    y: 23.85,
    width: 29.43,
    height: 0.62,
    transform: "translate(-0.05 0.08) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 28.94,
    y: 35.25,
    width: 18.52,
    height: 0.62,
    transform: "translate(-0.07 0.07) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 28.93,
    y: 31.55,
    width: 18.52,
    height: 0.62,
    transform: "translate(-0.06 0.07) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 28.94,
    y: 38.5,
    width: 29.43,
    height: 0.62,
    transform: "translate(-0.07 0.08) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 28.95,
    y: 42.21,
    width: 29.43,
    height: 0.62,
    transform: "translate(-0.08 0.08) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 28.96,
    y: 46.26,
    width: 29.43,
    height: 0.62,
    transform: "translate(-0.09 0.08) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 28.7,
    y: 3.85,
    width: 30.48,
    height: 6.06,
    transform: "translate(-0.01 0.08) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 48.93,
    y: 28.65,
    width: 9.15,
    height: 8.93,
    transform: "translate(-0.06 0.1) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M22.63,14.67V11.42a3.27,3.27,0,0,0-3.28-3.27H3.28A3.27,3.27,0,0,0,0,11.42V53.59a3.28,3.28,0,0,0,3.28,3.27H58.73A3.28,3.28,0,0,0,62,53.59V21.22a3.28,3.28,0,0,0-3.28-3.28H25.91a3.27,3.27,0,0,1-3.28-3.27"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpeta);
export default __webpack_public_path__ + "static/media/carpeta.26d1599edd52973b67cc789c35399b2a.svg";
export { ForwardRef as ReactComponent };